(function($) {
	'use strict';

	$.widget('msv.carousel', {

		options: {},

		_create: function() {
			var self = this,
				videoElement = this.element.find('.hero--video'),
				settingsElement = this.element.data('settings'),
				slideAmount = this.element.find("> div").length;

			/**/

			if (slideAmount > 1) {
				if (settingsElement) {
					self.settings = JSON.parse($(settingsElement).text());
				}

				if (self.settings.identifier == "eventos") {

					if (window.innerWidth > 960) {

						this.element.owlCarousel(self.settings);

					}
					$(window).resize(function() {

						self._handleCarousel();
					});

				}
				else {
					if (videoElement.length) {
						if (window.innerWidth > 960) {
							this.element.owlCarousel(self.settings)
								.on('translate.owl.carousel', function() {
									videoElement.find('video').each(function() {
										$(this).get(0).pause();
										!$(this).get(0).muted ? $(this).get(0).muted = true : '';
									})
								})
								.on('translated.owl.carousel', function() {
									videoElement.parent('.active').find('video').get(0).play();
								})
							videoElement.each(function() {
								var src = $(this).data('video');
								if (typeof src !== typeof undefined && src !== false) {
									$(this).prepend('<video muted><source src="' + src + '" type="video/mp4"></video>')
								}
							})
							videoElement.parent('.active').find('video').attr({ 'autoplay': true, 'loop': true })
						}
					}
					this.element.owlCarousel(self.settings);
				}
			}
		},

		_handleCarousel: function() {
			var self = this;

			if (window.innerWidth < 960) {
				self.element.trigger('destroy.owl.carousel');

			}
			else {

				self.element.owlCarousel(self.settings);

			}
		}

	});

})(jQuery);